import { ButtonBase } from '@mui/material';
import { useActionButtonSingleStyles } from './action-button-single.styles';

export function ActionButtonSingle({
  onClick,
  Icon,
  label,
  style
}: {
  onClick(): void;
  Icon: any;
  label: string;
  style?: React.CSSProperties;
}) {
  const classes = useActionButtonSingleStyles();
  return (
    <ButtonBase onClick={onClick} className={`${classes.button}`} style={style}>
      {Icon && (
        <>
          <Icon /> &nbsp;
        </>
      )}{' '}
      {label}
    </ButtonBase>
  );
}
